import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import Stats from "./components/Stats";
import About from "./components/About";
import Services from "./components/Services";
import Catalog from "./components/Catalog";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ScrollToHash from "./components/ScrollToHash";
import SmoothScroll from "./components/SmoothScroll";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CustomerProfile from "./pages/CustomerProfile";
import AdminDashboard from "./pages/AdminDashboard";
import CategoryPage from "./pages/CategoryPage";
import ProtectedRoute from "./components/ProtectedRoute";

const Landing = () => (
  <div className="min-h-screen bg-background text-foreground">
    <Header />
    <main>
      <Hero />
      <Ticker />
      <Stats />
      <About />
      <Services />
      <Catalog />
      <Partners />
      <Contact />
    </main>
    <Footer />
    <FloatingWhatsApp />
    <Toaster position="top-right" richColors closeButton />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <AuthProvider>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/catalogo/:categoryId" element={<CategoryPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/admin/login" element={<Navigate to="/login" replace />} />
            <Route
              path="/perfil"
              element={
                <ProtectedRoute role="customer">
                  <CustomerProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
